/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const aPIImportFilterUsersItemUsernameMax = 150;

export const aPIImportFilterUsersItemUsernameRegExp = new RegExp('[\\w.@+-]+');
export const aPIImportFilterUsersItemFirstNameMax = 150;

export const aPIImportFilterUsersItemLastNameMax = 150;

export const APIImportFilter = zod.strictObject({
    users: zod.array(
        zod.strictObject({
            id: zod.number(),
            username: zod
                .string()
                .max(aPIImportFilterUsersItemUsernameMax)
                .regex(aPIImportFilterUsersItemUsernameRegExp)
                .describe(
                    'Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.',
                ),
            first_name: zod
                .string()
                .max(aPIImportFilterUsersItemFirstNameMax)
                .optional(),
            last_name: zod
                .string()
                .max(aPIImportFilterUsersItemLastNameMax)
                .optional(),
        }),
    ),
    app_ids: zod.array(zod.string()),
    app_versions: zod.array(zod.string()),
});

export type APIImportFilter = zod.input<typeof APIImportFilter>;
export type APIImportFilterOutput = zod.output<typeof APIImportFilter>;
